import { render, staticRenderFns } from "./CCTalent.vue?vue&type=template&id=4a1c4152&"
import script from "./CCTalent.vue?vue&type=script&lang=ts&"
export * from "./CCTalent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports